import type { FontFaceSpec } from '../../types';
import woff2 from '../src/PPMori-BookNew.woff2';
import woff from '../src/PPMori-BookNew.woff';

export const ppMoriBook: FontFaceSpec = {
  weight: 350,
  style: 'normal',
  src: [
    { file: woff2, format: 'woff2' },
    { file: woff, format: 'woff' },
  ],
};
